export const ContactUs = {
  name: {
    required: {value: true, message: "* وارد کردن نام اجباری است."},
    maxLength: {value: 60, message: "* نام نمیتواند بیشتر از 60 کاراکتر باشد."},
  },
  email: {
    required: {value: true, message: "* وارد کردن ایمیل اجباری است."},
    pattern: {value: /^\S+@\S+$/i, message: "* فرمت ایمیل درست نمیباشد."}
  },
  description: {
    required: {value: true, message: "* وارد کردن توضیحات اجباری است."},
    maxLength: {value: 4096, message: "* توضیحات نمیتواند بیشتر از ۴۰۹۶ کاراکتر باشد."}
  },
  captcha: {
    required: {value: true, message: "* وارد کردن کدامنیتی اجباری است."}
  }
}